import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LogoService } from '../../services/logo.service';


@Component({
  selector: 'app-header-public',
  templateUrl: './header-public.component.html',
  styleUrls: ['./header-public.component.scss'],
})
export class HeaderPublicComponent implements OnInit, OnDestroy {
  @Input() isDarkMode: boolean = false;

  logoUrl: string | null = null;
  private sub?: Subscription;

  constructor(private logo: LogoService) {}

  ngOnInit(): void {
    this.sub = this.logo.logoUrl$.subscribe(url => {
      this.logoUrl = url;
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
